import ChatTableRedirect from '@/tables/components/ChatTableRedirect'
import { redirectAliasedChatFeatureRoute } from '@/chat-common/conversation-navigation/util/redirect-aliased-chat-feature-route'
import type { RouteFactory } from '@/routing/types'
import AgentV2ChatRoute from '@/routes/dashboard/AgentV2ChatRoute'
import ChatsPage from '@/agent-v2/conversations/components/ChatsPage'
import { kRouteSegments } from '@/routing/paths'

/**
 * Creates chat routes for nesting under MatterLayout.
 * URL pattern: /dashboard/m/:matterId/chat/:chatFeature/:chatId?
 *
 * @see MatterLayout for parent route context
 */
export const createChatChildRoutes: RouteFactory = () => [
  {
    path: 'chat/:chatFeature',
    // Handles feature aliasing (e.g. drafting → agent)
    loader: redirectAliasedChatFeatureRoute,
    children: [
      // Chat without chatId
      {
        index: true,
        element: <AgentV2ChatRoute />,
      },
      // Chat with specific conversation
      {
        path: ':chatId',
        element: <ChatTableRedirect />,
      },
    ],
  },
  { path: kRouteSegments.chats, element: <ChatsPage /> },
]
